
export default {
  props: {
    paymentLink: {
      required: false,
      type: String,
      default: '',
    },
  },

  computed: {
    showPaymentLink () {
      return !! this.paymentLink
    },
  },

  methods: {
    async proceedToPayment () {
      AndroidDevice.visit(this.paymentLink)
    },
  },
}
